import * as Highcharts from 'highcharts';
import { ReusableFunctions } from '../classes/reusable-functions';

export class StreamgraphChartOptions {
    constructor(private reusableFunctions: ReusableFunctions) {}

    loadloadChartOptions(seriesData: Array<any>, titleData) {
        let highChartsOptions: Highcharts.Options;

        Highcharts.setOptions({
            lang: {
                thousandsSep: ',',
            },
        });
        const _this = this;

        highChartsOptions = {
            chart: {
                type: 'streamgraph',
                spacingBottom: 24,
                zooming: {
                    type: 'xy',
                },
                style: {
                    fontFamily: 'Roboto',
                },
                height: 600,
            },

            title: titleData,

            xAxis: {
                maxPadding: 0,
                type: 'category',
                crosshair: true,
                title: {
                    text: '',
                    style: {
                        fontSize: '10px',
                        color: '#666666',
                    },
                },
                labels: {
                    enabled: true,
                    align: 'left',
                    reserveSpace: false,
                    rotation: 270,
                    style: {
                        fontSize: '10px',
                        color: '#666666',
                    },
                },
                lineWidth: 0,
                margin: 20,
                offset: 40,
                gridLineColor: 'transparent',
            },

            yAxis: {
                visible: true,
                startOnTick: false,
                endOnTick: false,
                title: {
                    text: 'Volume ($)',
                    style: {
                        fontSize: '10px',
                        color: '#666666',
                    },
                },
                labels: {
                    enabled: false,
                    style: {
                        fontSize: '10px',
                        color: '#666666',
                    },
                },
                gridLineColor: 'transparent',
            },

            legend: {
                enabled: false,
            },

            annotations: [
                {
                    labels: [
                        {
                            point: {
                                x: 5.5,
                                xAxis: 0,
                                y: 30,
                                yAxis: 0,
                            },
                            text: '',
                        },
                        {
                            point: {
                                x: 18,
                                xAxis: 0,
                                y: 90,
                                yAxis: 0,
                            },
                            text: '',
                        },
                    ],
                    labelOptions: {
                        backgroundColor: 'rgba(255,255,255,0.5)',
                        borderColor: 'silver',
                    },
                },
            ],

            tooltip: {
                backgroundColor: '#FFFFFF',
                borderColor: '#223540',
                borderRadius: 8,
                style: {
                    color: '#223540',
                    fontFamily: 'Roboto',
                    padding: '8',
                    textOverflow: 'ellipsis',
                },
                shared: true,
                useHTML: true,
                outside: true,
                formatter: function () {
                    const totalVolume = this.points.reduce((sum, { y }) => sum + y, 0);
                    let totalUnits = 0;
                    for (let x of this.points) {
                        totalUnits += x.point.properties.units;
                    }
                    const volumePercents = _this.reusableFunctions.getRefinedPercents(
                        this.points.map((number) => (number.y / totalVolume) * 100)
                    );
                    const totalPercents = volumePercents.reduce((sum, x) => sum + x, 0);
                    let tooltip =
                        '<table>' +
                        this.points.reduce(function (s, point, index) {
                            if (index === 0) {
                                s +=
                                    '<tr style="line-height: 18px; font-size: 16px"> <td colSpan="4"> <b>' +
                                    point.point.name +
                                    '<b></td></tr>';
                            }
                            s +=
                                '<tr style="display:' +
                                point.point.properties.display +
                                '"><td style="color:' +
                                point.point.color +
                                '; padding-right: 10px;;"><b>' +
                                point.point.properties.hierarchyName.toUpperCase() +
                                '</b></td><td style="text-align: right;">' +
                                _this.reusableFunctions.formatMoney(point.y) +
                                '</td><td style="padding: 0 5px 0 5px">/</td>' +
                                '<td style="text-align: right;">' +
                                point.point.properties.units.toLocaleString() +
                                '</td><td style="padding: 0 5px 0 5px">/</td>' +
                                '<td style="text-align: right;">' +
                                volumePercents[index].toFixed(0).toLocaleString() +
                                '%' +
                                '</td></tr>';
                            return s;
                        }, '') +
                        '</table>';
                    let totals =
                        '<hr/>' +
                        `<div><span style="padding-right: 52px; font-weight: bold">TOTAL</span><span style="padding-right:7px">${_this.reusableFunctions.formatMoney(
                            totalVolume
                        )}</span><span>/</span><span style="padding-left: 10px;padding-right: 6px;">${totalUnits}</span><span>/ ${totalPercents}%</span></div>`;
                    tooltip += totals;
                    return tooltip;
                },
            },

            plotOptions: {
                series: {
                    label: {
                        minFontSize: 5,
                        maxFontSize: 15,
                        style: {
                            color: 'rgba(255,255,255,0.75)',
                        },
                    },
                },
                streamgraph: {
                    allAreas: true,
                },
            },

            series: seriesData,

            exporting: {
                enabled: false,
                sourceWidth: 800,
                sourceHeight: 600,
            },

            credits: {
                enabled: false,
            },
        };
        return highChartsOptions;
    }
}
